import * as zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

function paymentWidget() {
	return postJSONPS('GET', '/widget/payment/url', {}).then(
		either(console.log, ({ url }) => {
			let PaymentWidget = zoid.create({
				tag: 'payment-widget',
				url
			});
			console.log('LWIDGET: login-widget loaded.');
			console.log(PaymentWidget);

			return PaymentWidget;
		})
	);
}

export default paymentWidget;
